import { lazy } from 'react';

// Marketplace-specific lazy routes
export const MarketPlace = lazy(() => import('pages/MarketPlace'));
export const BarterCalculator = lazy(() => import('pages/Calculator/BarterCalculator'));
export const MarketPlaceExplore = lazy(() => import('components/MarketPlaceExplore/ProductList'));
export const UnifiedProductListPage = lazy(() => import('components/Marketplace/UnifiedProductList/UnifiedProductListPage'));
export const UnifiedProductPreview = lazy(() => import('components/common/previewTemplates/UnifiedProductPreview'));
export const UnifiedcategoryBase = lazy(() => import('components/Marketplace/UnifiedCategoryBase/UnifiedcategoryBase'));
export const BrandProductsPage = lazy(() => import('pages/Marketplace/BrandProductsPage'));
export const ReadyStockPage = lazy(() => import('pages/Marketplace/ReadyStockPage'));


